import { Controller } from "react-hook-form";
import { UrduInput } from "../../../../Components/Shared/UrduInput";
import { RichTextEditor } from "../../../../Components/Shared/RichTextEditor";
import FieldError from "./FieldError";

export default function DescriptionsSection({ form }) {
  const { formData, control, validationErrors, handleChange, clearFieldErrors } =
    form;

  return (
    <section data-field="description" className="pf-card">
      <h3 className="pf-section-title mb-5">Product Content</h3>

      <div className="space-y-4">
        <div>
          <label className="pf-label">Short Description (Marketing Blurb)</label>
          <textarea
            name="shortDescription"
            value={formData.shortDescription}
            onChange={handleChange}
            placeholder="Brief summary shown in listings"
            className="pf-textarea min-h-[72px] resize-y"
          />
          <UrduInput
            label="مختصر تفصیل"
            name="shortDescription_ur"
            value={formData.shortDescription_ur}
            onChange={handleChange}
            type="textarea"
            rows={2}
          />
        </div>

        <div data-field="description">
          <label className="pf-label">
            Full Technical Description <span className="text-red-500">*</span>
          </label>
          <div
            className={
              validationErrors.description
                ? "rounded-lg ring-1 ring-red-500"
                : ""
            }
          >
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <RichTextEditor
                  value={field.value || ""}
                  onChange={(html) => {
                    field.onChange(html);
                    clearFieldErrors("description");
                  }}
                  placeholder="Write a detailed product description"
                  minHeight={180}
                  maxHeight={420}
                />
              )}
            />
          </div>
          <FieldError message={validationErrors.description} />
          <div className="mt-3">
            <label
              className="block text-sm font-bold text-gray-800 mb-1.5 text-right"
              dir="rtl"
            >
              تفصیل
            </label>
            <Controller
              name="description_ur"
              control={control}
              render={({ field }) => (
                <RichTextEditor
                  dir="rtl"
                  value={field.value || ""}
                  onChange={field.onChange}
                  placeholder="اردو میں تفصیل لکھیں..."
                  minHeight={180}
                  maxHeight={420}
                />
              )}
            />
          </div>
        </div>
      </div>
    </section>
  );
}
